/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateRangeInput
 */
export interface DateRangeInput {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof DateRangeInput
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof DateRangeInput
     */
    until?: string;
}

/**
 * Check if a given object implements the DateRangeInput interface.
 */
export function instanceOfDateRangeInput(value: object): value is DateRangeInput {
    return true;
}

export function DateRangeInputFromJSON(json: any): DateRangeInput {
    return DateRangeInputFromJSONTyped(json, false);
}

export function DateRangeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRangeInput {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
    };
}

export function DateRangeInputToJSON(json: any): DateRangeInput {
    return DateRangeInputToJSONTyped(json, false);
}

export function DateRangeInputToJSONTyped(value?: DateRangeInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
    };
}

